import React from 'react';
import PropTypes from 'prop-types';

import AccountsField from '../../../shared/AccountsField';
import StepHeader from './StepHeader';
import { ACCOUNT_STEP } from './copy';
import { POPOVER_Z_INDEX } from './layers';
import { StepBody } from './styles';

/**
 * Step 1: which accounts the new user belongs to.
 *
 * The mockup also shows a required Team select above the accounts. PD-4064 does
 * not build it — the grooming notes defer Teams, and there is no Team model until
 * PD-4213 — so this step is the Account field alone.
 */
function AccountStep({
  hasMore,
  isLoading,
  onChange,
  onLoadMore,
  onSearchAccounts,
  options,
  selected,
  total,
}) {
  return (
    <StepBody>
      <StepHeader
        showRequiredKey
        subtitle={ACCOUNT_STEP.subtitle}
        title={ACCOUNT_STEP.title}
      />
      <AccountsField
        emptyText={ACCOUNT_STEP.empty}
        hasMore={hasMore}
        help={ACCOUNT_STEP.help}
        inputId="create-user-accounts-input"
        isLoading={isLoading}
        label={ACCOUNT_STEP.label}
        listId="create-user-accounts-list"
        loadingMoreText={ACCOUNT_STEP.loadingMore}
        options={options}
        pagedText={ACCOUNT_STEP.paged}
        searchPlaceholder={ACCOUNT_STEP.searchPlaceholder}
        selected={selected}
        toggleAriaLabel={ACCOUNT_STEP.toggle}
        total={total}
        zIndex={POPOVER_Z_INDEX}
        onChange={onChange}
        onLoadMore={onLoadMore}
        onSearch={onSearchAccounts}
      />
    </StepBody>
  );
}

AccountStep.propTypes = {
  hasMore: AccountsField.propTypes.hasMore,
  isLoading: AccountsField.propTypes.isLoading,
  onChange: PropTypes.func.isRequired,
  onLoadMore: AccountsField.propTypes.onLoadMore,
  onSearchAccounts: PropTypes.func.isRequired,
  options: AccountsField.propTypes.options,
  selected: AccountsField.propTypes.selected,
  total: AccountsField.propTypes.total,
};

AccountStep.defaultProps = {
  hasMore: false,
  isLoading: false,
  onLoadMore: () => {},
  options: [],
  selected: [],
  total: 0,
};

export default AccountStep;
